import { slideUp, slideDown, slideToggle } from './slide'
import scrollTo from './scrollTo'

window.App = {}

window.App.SlideToggle = () => {
  return {
    active: false,
    toggle() {
      const $target = this.$el.querySelector(`[data-toggle-target]`)
      slideToggle($target).then(scrollTo(this.$el))

      this.active = !this.active
    },
    isActive() {
      return this.active
    },
  }
}

window.App.SlideToggleGroup = () => {
  return {
    activeId: null,
    toggleItem(id) {
      const $target = this.$el.querySelector(`[data-toggle-id="${id}"]`)

      if (this.activeId === id) {
        this.activeId = null
        slideUp($target)
      } else {
        this.activeId = id
        slideDown($target)
        this.closeOthers(id)
      }
    },
    closeOthers(id) {
      this.$el.querySelectorAll('[data-toggle-id]').forEach(($target) => {
        if (parseInt($target.dataset.toggleId, 10) !== id) {
          slideUp($target)
        }
      })
    },
    isItemActive(id) {
      return this.activeId === id
    },
  }
}

window.App.AccordionTabs = () => {
  return {
    asTabs: window.innerWidth >= 768,
    activeId: null,
    isActive(id) {
      return this.activeId === id
    },
    setActive(id) {
      this.activeId = id
    },
    toggle(id) {
      const $target = this.$el.querySelector(`[data-toggle-id="${id}"]`)

      if (this.activeId === id) {
        this.activeId = null
        slideUp($target)
      } else {
        this.activeId = id
        slideDown($target)
        this.closeOthers(id)
        setTimeout(() => {
          scrollTo($target, 60)
        }, 500)
      }
    },
    closeOthers(id) {
      this.$el.querySelectorAll('[data-toggle-id]').forEach(($target) => {
        if (parseInt($target.dataset.toggleId, 10) !== id) {
          slideUp($target)
        }
      })
    },
  }
}
